import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Badge as MUIBadge, } from "@mui/material";
import { convertPxToRem } from "../../../util-functions";
const handleColorVariant = (colorVariant, disabled, theme) => {
    if (disabled) {
        return {
            backgroundColor: theme.palette.grey04.main,
            color: theme.palette.disabledText.main,
        };
    }
    switch (colorVariant) {
        case "primary":
            return {
                backgroundColor: theme.palette.primaryBlack.main,
                color: theme.palette.primaryWhiteText.main,
            };
        case "secondary":
            return {
                backgroundColor: theme.palette.green08.main,
                color: theme.palette.primaryWhiteText.main,
            };
        default: // neutral color
            return {
                backgroundColor: theme.palette.grey03.main,
                color: theme.palette.secondaryText.main,
            };
    }
};
const StyledBadgeCounter = styled(MUIBadge, {
    shouldForwardProp: (prop) => prop !== "colorVariant" && prop !== "disabled",
})(({ theme, badgeContent, colorVariant, disabled }) => ({
    "& .MuiBadge-badge": handleColorVariant(colorVariant, disabled, theme),
    "& .MuiBadge-standard": Object.assign(Object.assign({}, theme.typography.extraSmallTextStrong), { borderRadius: convertPxToRem(6), lineHeight: "initial", padding: `0 ${convertPxToRem(4)}`, 
        // Using the bottom right anchor to create an inline style
        "&.MuiBadge-anchorOriginBottomRight": {
            transform: badgeContent
                ? "scale(1) translate(100%, 0)"
                : "scale(0) translate(100%, 0)",
            right: convertPxToRem(-4),
        }, 
        // Using the bottom left anchor to create an inline style
        "&.MuiBadge-anchorOriginBottomLeft": {
            transform: badgeContent
                ? "scale(1) translate(-100%, 0)"
                : "scale(0) translate(-100%, 0)",
            left: convertPxToRem(-4),
        } }),
}));
export const BadgeCounter = ({ badgeContent, counterLeftPlacement = false, children, disabled = false, colorVariant = "primary", invisible = false, testId, variant = "dot", }) => {
    const badgePlacement = variant === "dot"
        ? { vertical: "top", horizontal: "right" }
        : // this is really the inline placement, but needed to use MUI's bottom-right anchorOrigin to add custom style
            {
                vertical: "bottom",
                horizontal: counterLeftPlacement ? "left" : "right",
            };
    const badgeVariant = variant === "counter" ? "standard" : "dot";
    return (_jsx(StyledBadgeCounter, Object.assign({ "data-testid": testId, badgeContent: badgeContent, colorVariant: colorVariant, invisible: invisible, variant: badgeVariant, anchorOrigin: badgePlacement, disabled: disabled }, { children: children })));
};
